<template>
  <div class="nav-page-view-box">
    <div class="stance"></div>
    <div class="nav-page-view flex-middle-x layout-flex-center">
      <div class="flex-middle-x">
        <img :src="logo" alt="">
      </div>
      <ul class="flex-middle-x">
        <li v-for="(item,index) in navList"
            @click="actionClickNavTab(item.id)"
            :class="{ 'hover': index === tabHover}">
          {{item.name}}
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
  export default {
    name: '',
    data() {
      return {
        logo: require('./image/logo.png'),
        tabHover: 0
      }
    },
    props: {
      tabHoverPage: {
        default: Number
      }
    },
    computed: {
      navList() {
        return [
          {id: 0, name: '网站首页'},
          {id: 1, name: '产品信息'},
          {id: 2, name: '团队介绍'},
          {id: 3, name: '合作伙伴'},
          {id: 4, name: '关于我们'}
        ]
      }
    },
    methods: {
      actionClickNavTab(id) {
        this.tabHover = id;
        window.scrollTo(0, 0)
        if (id === 0) {
          this.$router.push({name: 'ComputerHomePage'});
        } else if (id === 1) {
          this.$router.push({name: 'ProductInformationPage'});
        } else if (id === 2) {
          this.$router.push({name: 'TeamIntroductionPage'});
        } else if (id === 3) {
          this.$router.push({name: 'PartnerPageView'});
        } else if (id === 4) {
          this.$router.push({name: 'AboutUsPage'});
        }
      }
    },
    mounted() {
      this.tabHover = this.tabHoverPage;
    }
  }
</script>
<style lang="scss" rel="stylesheet/scss" scoped="">
  .nav-page-view-box {
    .stance{
      width: 100%;
      min-width: 1200px;
      height: 73px;
    }
    .nav-page-view {
      width: 100%;
      min-width: 1200px;
      height: 73px;
      margin: auto;
      background: $color-4;
      position: fixed;
      top: 0;
      left: 0;
      z-index: 100;
      box-shadow: 1px 0px 3px #ccc;
      div {
        img {
          width: 400px;
        }
      }
      ul {
        margin-left: 60px;
        li {
          font-size: 16px;
          color: $color-1;
          border-bottom: 2px solid transparent;
          margin-left: 60px;
          padding: 23px 10px;
          cursor: pointer;
          white-space: nowrap;
          position: relative;
          top: 1px;
        }
        li:hover {
          color: #ffbd1f;
          border-bottom: 2px solid #ffbd1f;
        }
        .hover {
          color: #ffca4c;
          border-bottom: 2px solid #ffbd1f;
        }
      }
    }
  }
</style>
